import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/sections/Hero';
import { TrustedBy } from './components/sections/TrustedBy';
import { WorldClassTalent } from './components/sections/WorldClassTalent';
import { Testimonials } from './components/sections/Testimonials';
import { ExploreYourPath } from './components/sections/ExploreYourPath';
import { Footer } from './components/sections/Footer';
import { CaseStudyDetail } from './components/pages/CaseStudyDetail';
import { BookingPage } from './components/pages/BookingPage';
import { FractionalPM } from './components/pages/FractionalPM';
import { FractionalHeadOfAI } from './components/pages/FractionalHeadOfAI';
// Homepage - lean switchboard
const Home = () => {
  return <main data-id="element-0">
      <Hero data-id="element-1" />
      <TrustedBy data-id="element-2" />
      <WorldClassTalent data-id="element-3" />
      <Testimonials data-id="element-4" />
      <ExploreYourPath data-id="element-5" />
    </main>;
};
export function App() {
  return <BrowserRouter data-id="element-6">
      <div className="font-sans" data-id="element-7">
        <Navbar data-id="element-8" />
        <Routes data-id="element-9">
          <Route path="/" element={<Home data-id="element-11" />} data-id="element-10" />
          <Route path="/fractional-pm" element={<FractionalPM data-id="element-13" />} data-id="element-12" />
          <Route path="/fractional-head-of-ai" element={<FractionalHeadOfAI data-id="element-15" />} data-id="element-14" />
          <Route path="/case-study/:id" element={<CaseStudyDetail data-id="element-17" />} data-id="element-16" />
          <Route path="/book-meeting" element={<BookingPage data-id="element-19" />} data-id="element-18" />
        </Routes>
        <Footer data-id="element-20" />
      </div>
    </BrowserRouter>;
}